var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableActions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 19,
    viewBox: "0 0 35 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.494141,
    width: 34.3255,
    height: 19,
    rx: 9.5,
    fill: "#FBDBE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5895 12C11.7046 12 12.6086 11.1046 12.6086 10C12.6086 8.89543 11.7046 8 10.5895 8C9.47432 8 8.57031 8.89543 8.57031 10C8.57031 11.1046 9.47432 12 10.5895 12ZM19.6731 10C19.6731 11.1046 18.7691 12 17.6539 12C16.5388 12 15.6348 11.1046 15.6348 10C15.6348 8.89543 16.5388 8 17.6539 8C18.7691 8 19.6731 8.89543 19.6731 10ZM26.7375 10C26.7375 11.1046 25.8335 12 24.7184 12C23.6032 12 22.6992 11.1046 22.6992 10C22.6992 8.89543 23.6032 8 24.7184 8C25.8335 8 26.7375 8.89543 26.7375 10Z",
    fill: "#F1557F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableActions);
export default __webpack_public_path__ + "static/media/table-actions.66fcd71ec8e812428626d17561434f01.svg";
export { ForwardRef as ReactComponent };